module.exports = __webpack_public_path__ + "static/media/grey_diagonal_line.d63d6d87.svg";